import styled from "styled-components";

import { Small } from "@Components/Basic";

export const ExpirationDate = styled(Small)`
    display: inline-block;
    line-height: 14px;
`;
